import React from 'react';
import { Button, Dimmer, Grid, Loader,Table, Modal, Dropdown, TextArea, Icon, Message } from 'semantic-ui-react';
import PropTypes from "prop-types";
import DataProvider from "./data-providers/data-provider";
import ExportDataProvider from "./data-providers/export-data-provider";
import CsvExportDataProvider from "./data-providers/csv-export-data-provider";
import { Observable } from "rxjs";
import * as api from '../../api'
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import dateFormat from "dateformat";
import "react-datepicker/dist/react-datepicker.css";


function Header() { return null }
function Footer() { return null }

export default class QsrCommentaryDataTable extends React.Component {

    static Header = Header;
    static Footer = Footer;

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            isLoading: false,
            dataProvider: this.props.dataProvider,
            exportDataProvider: this.props.exportDataProvider || new CsvExportDataProvider(),
            sortSettings: {
                sort: this.props.defaultSort || '',
                order: "desc",
            },

            commitSuccess: false,
            open: false,

            startDate: new Date(),
            areas: [],
            eventTypes: [],
            errorMessage: false,
            isEventTriggered: false,

            selectedAreas: [],
            selectedEventTypes: [],
            comment: "",
            actionToImprove: "",

            isAreasEmpty: false,
            isEventTypeEmpty: false,
            isCommentEmpty: false,
            isActionEmpty: false

        };
    }

    componentDidMount() {
        this.refreshData();

        const area = "Area";
        const event = "Event";
        try {
            api.getAreaOrEventTypes(area)
                .then(verifyRes => {
                    this.setState({ areas: verifyRes })

                })
        } catch (err) {

           
        }

        try {
            api.getAreaOrEventTypes(event)
                .then(verifyRes => {
                    this.setState({ eventTypes: verifyRes })

                })
        } catch (err) {

           
        }
    }

    componentDidUpdate() {
        if (this.state.commitSuccess) {

            this.refreshData();
            this.setState({
                commitSuccess: false
            });
        }

    }

    get getDataProviderContext() {
        const defaultContext = {
            sortSettings: this.state.sortSettings,
            name: this.props.name
        };

        if (!this.props.additionalProviderContext) { return defaultContext; }

        return { ...defaultContext, ...this.props.additionalProviderContext() };
    }

    getSlot(slotType) {
        const children = this.props.children || {};
        if (children.find) { return children.find(child => child.type === slotType); }
        return children.type === slotType ? children : null;
    }

    get headerSlot() { return this.getSlot(Header); }
    get footerSlot() { return this.getSlot(Footer); }

    get showExport() {
        return this.props.headerComponent.Layout && (typeof (this.props.canExport) === "undefined") ? true : this.props.canExport
    }

    UNSAFE_componentWillMount() {
        if (this.props.refreshDataTrigger) { this.props.refreshDataTrigger.subscribe(this.refreshData); }
    }

    componentWillUnmount() {
        if (this.props.refreshDataTrigger && this.props.refreshDataTrigger.unsubscribe) { this.props.refreshDataTrigger.unsubscribe(this.refreshData); }
    }

    onChangeSort = clickedColumn => {
        const { sort, order } = this.state.sortSettings;

        let newOrder = order === 'asc' ? 'desc' : 'asc';
        if (sort !== clickedColumn) {
            newOrder = 'asc';
        }

        const sortSettings = { sort: clickedColumn, order: newOrder };
        this.setState({ sortSettings }, this.refreshData);
    };

    refreshData = () => {
        const loadingTimeout = setTimeout(() => {
            this.setState({ isLoading: true });
        }, 500);

        return this.state.dataProvider
            .refreshData(this.getDataProviderContext)
            .then((data) => {
                clearTimeout(loadingTimeout);
                this.setState({ data: data.elements, isLoading: false });
                if (this.props.onTableRefreshed) { this.props.onTableRefreshed(data); }
            });
    };

    exportData = () => {


        this.state.exportDataProvider
            .exportData(this.state.dataProvider, this.props.headerComponent.Layout, this.getDataProviderContext);

    };

    onModalChange = (e, { name, value }) => {
        this.setState({ isAreasEmpty: false, isEventTypeEmpty: false, isCommentEmpty: false, isActionEmpty: false })
        if (!value.length) { this.setState({ errorMessage: false, selectedEventTypes: [] }) }
        let len = value.length;
        if (name === "selectedAreas") {
            if (value[len - 1] === "Waste" || value[len - 1] === "Gas Consumption" || value[len - 1] === "Electricity Consumption" || value[len - 1] === "Water Consumption") {
                if (len === 1) {
                    this.setState({ [name]: value, isEventTriggered: true, errorMessage: false })
                }
                else if (len > 1 && (value[len - 2] === "Waste" || value[len - 2] === "Gas Consumption" || value[len - 2] === "Electricity Consumption" || value[len - 2] === "Water Consumption")) {
                    this.setState({ [name]: value, isEventTriggered: true })
                } else {
                    this.setState({ [name]: value, isEventTriggered: true, errorMessage: true })
                }

            } else {
                if (len === 1) {

                    this.setState({ [name]: value, isEventTriggered: false, selectedEventTypes: [], errorMessage: false })
                }
                else if (len > 1 && (value[len - 2] === "Waste" || value[len - 2] === "Gas Consumption" || value[len - 2] === "Electricity Consumption" || value[len - 2] === "Water Consumption")) {
                    this.setState({ [name]: value, isEventTriggered: false, selectedEventTypes: [], errorMessage: true })
                } else {

                    this.setState({ [name]: value, isEventTriggered: false, selectedEventTypes: [] })
                }
            }

        } else {
            if (name === "selectedEventTypes") {

                this.setState({ [name]: value })
            } else {
                this.setState({ [name]: value })

            }
        }

    }

    handleQsrCommentarySubmit = () => {

        if (!this.state.selectedAreas.length || (this.state.isEventTriggered && !this.state.selectedEventTypes.length) || !this.state.comment.length || !this.state.actionToImprove.length || this.state.errorMessage) {
            if (!this.state.selectedAreas.length) { this.setState({ isAreasEmpty: true }) }
            if (!this.state.selectedEventTypes.length) { this.setState({ isEventTypeEmpty: true }) }
            if (!this.state.comment.length) { this.setState({ isCommentEmpty: true }) }
            if (!this.state.actionToImprove.length) { this.setState({ isActionEmpty: true }) }
            return;
        }
        const formData = new FormData();

        formData.append("SiteKey", this.props.dataProvider.apiArgs[1])
        formData.append("CustomerId", this.props.dataProvider.apiArgs[0])
        formData.append("FldDate", dateFormat(this.state.startDate, "isoDate"));
        formData.append("Area", this.state.selectedAreas);
        formData.append("Event", this.state.selectedEventTypes);
        formData.append("Comments", this.state.comment);
        formData.append("Action", this.state.actionToImprove);

        try {
            api.postQsrCommentary(formData)
                .then(verifyRes => {
                    if (verifyRes === true) {
                        this.setState({

                            commitSuccess: true,
                            open: false,
                            errorMessage: false,
                            isEventTriggered: false
                        });
                        this.notify();
                    }

                })
          
        } catch (err) {

        }
        this.setState({
            startDate: new Date(),
            selectedAreas: [],
            selectedEventTypes: [],
            comment: "",
            actionToImprove: ""
        })

    }
    notify = () => {
        toast.success("Successfully saved !", {
            position: toast.POSITION.TOP_CENTER,
            delay: 500
        });
    }

    render() {
        const HeaderTag = this.props.headerComponent;
        const RowTag = this.props.rowComponent;
        const rowContent = this.state.data.map((element, index) => (
            <RowTag key={index} data={element} contextData={this.props.contextData} />
        ));

        const areaOptions = [];
        const eventOptions = [];
        for (let i = 0; i < this.state.areas.length; i++) {
            areaOptions.push({ key: this.state.areas[i], text: this.state.areas[i], value: this.state.areas[i] })
        }

        for (let i = 0; i < this.state.eventTypes.length; i++) {
            eventOptions.push({ key: this.state.eventTypes[i], text: this.state.eventTypes[i], value: this.state.eventTypes[i] })
        }

        return (


            <React.Fragment>
                <div className="data-table">
                    <Dimmer active={this.state.isLoading}>
                        <Loader indeterminate>Refreshing Table</Loader>
                    </Dimmer>
                    <Grid stackable columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                {!!this.headerSlot && this.headerSlot.props.children}
                            </Grid.Column>
                            {this.showExport &&
                                <Grid.Column floated='right' width={3}>
                                    <Button compact floated='right' color='orange' onClick={this.exportData}>Export Data</Button>

                                    <Modal
                                        size={'large'}
                                        trigger={<Button compact floated='right' color='orange' >Log QSR Commentary</Button>}
                                        onClose={() => this.setState({
                                            open: false, errorMessage: false, isEventTriggered: false, isAreasEmpty: false, isEventTypeEmpty: false, isCommentEmpty: false, isActionEmpty: false, selectedAreas: [],
                                            selectedEventTypes: [],
                                            comment: "",
                                            actionToImprove: "",
                                        })}
                                        onOpen={() => this.setState({ open: true })}
                                        open={this.state.open}
                                    >

                                        <Modal.Header style={{ color: "white", backgroundColor: "black" }}>Log QSR Commentary
                                            <Modal.Actions style={{ display: "inline", float: "right" }}>
                                                <Icon name='close' className="cursorpointer" onClick={() => this.setState({
                                                    open: false, errorMessage: false, isEventTriggered: false, isAreasEmpty: false, isEventTypeEmpty: false, isCommentEmpty: false, isActionEmpty: false, selectedAreas: [],
                                                    selectedEventTypes: [],
                                                    comment: "",
                                                    actionToImprove: "",
                                                })} />
                                            </Modal.Actions>
                                        </Modal.Header>

                                        <Modal.Content>
                                            <Grid celled >
                                                <Grid.Row divided >
                                                    <Grid.Column>
                                                        <Modal.Header>
                                                            <h3>Please complete the form to log the QSR Commentary</h3>
                                                        </Modal.Header>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                            <Grid>
                                                <Grid.Row>
                                                    <Grid.Column width={3}> Date</Grid.Column>
                                                    <Grid.Column width={12}>
                                                        <label>
                                                            <DatePicker
                                                                className="qsr-date"
                                                                selected={this.state.startDate}
                                                                onChange={(date) => this.setState({ startDate: date })}
                                                                dateFormat="dd/MM/yyyy"
                                                                locale="en-GB"
                                                            />
                                                            <Icon name='calendar alternate outline' bordered={true} size={'large'} fitted={true} />
                                                        </label>
                                                    </Grid.Column>

                                                </Grid.Row>

                                                <Grid.Row>
                                                    <Grid.Column><h4>Please provide comments in all Areas that are applicable to your selection</h4> </Grid.Column>
                                                </Grid.Row>
                                                {this.state.errorMessage && <Grid.Row>
                                                    <Grid.Column width={15} >
                                                        <Message
                                                            error={true}
                                                            content="You have selected Areas with a mix of those that require Special Events and those that don't. You can not log a comment against both types. Please change your selected Areas."
                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>}

                                                <Grid.Row>
                                                    <Grid.Column width={3}>Areas</Grid.Column>
                                                    <Grid.Column width={12}>
                                                        <Dropdown placeholder='Select area'
                                                            fluid
                                                            multiple
                                                            selection
                                                            closeOnChange
                                                            options={areaOptions}
                                                            clearable
                                                            name="selectedAreas"
                                                            onChange={this.onModalChange}
                                                            style={this.state.isAreasEmpty ? { border: "1px solid red" } : null}
                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>

                                                {this.state.isEventTriggered && <Grid.Row>
                                                    <Grid.Column width={3}>Event Type</Grid.Column>
                                                    <Grid.Column width={12}>
                                                        <Dropdown placeholder='Select event type'
                                                            fluid
                                                            multiple
                                                            selection
                                                            closeOnChange
                                                            options={eventOptions}
                                                            clearable
                                                            name="selectedEventTypes"
                                                            onChange={this.onModalChange}
                                                            style={this.state.isEventTypeEmpty ? { border: "1px solid red" } : null}
                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>}

                                                <Grid.Row>
                                                    <Grid.Column width={3}>Comment</Grid.Column>
                                                    <Grid.Column width={12}>
                                                        <TextArea

                                                            name="comment"
                                                            onChange={this.onModalChange}
                                                            style={this.state.isCommentEmpty ? { minHeight: 100, minWidth: 815, border: "1px solid red" } : { minHeight: 100, minWidth: 815 }}

                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>

                                                <Grid.Row>
                                                    <Grid.Column width={3}>Action To Improve</Grid.Column>
                                                    <Grid.Column width={12}>
                                                        <TextArea

                                                            name="actionToImprove"
                                                            onChange={this.onModalChange}
                                                            style={this.state.isActionEmpty ? { minHeight: 100, minWidth: 815, border: "1px solid red" } : { minHeight: 100, minWidth: 815 }}

                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>

                                            </Grid>

                                        </Modal.Content>
                                        <Modal.Actions>

                                            <Button color="black" onClick={this.handleQsrCommentarySubmit} >Log Comment</Button>

                                        </Modal.Actions>

                                    </Modal>


                                </Grid.Column>}
                        </Grid.Row>
                    </Grid>
                    <Table striped padded selectable sortable>
                        <HeaderTag
                            column={this.state.sortSettings.sort}
                            contextData={this.props.contextData}
                            direction={this.state.sortSettings.order}
                            onChangeSort={this.onChangeSort}
                        />
                        <Table.Body>
                            {(this.state.data.length === 0) ? <React.Fragment /> : rowContent}
                        </Table.Body>
                        {!!this.footerSlot && this.footerSlot.props.children}
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}

QsrCommentaryDataTable.propTypes = {
    dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
    headerComponent: PropTypes.elementType.isRequired,
    rowComponent: PropTypes.elementType.isRequired,
    refreshDataTrigger: PropTypes.instanceOf(Observable),
    exportDataProvider: PropTypes.instanceOf(ExportDataProvider),
    onTableRefreshed: PropTypes.func,
    defaultSort: PropTypes.string,
    additionalProviderContext: PropTypes.func,
    name: PropTypes.string,
    canExport: PropTypes.bool,
    contextData: PropTypes.any
};

